import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import {
  ContentContainer,
  ContentHeader,
  ContentScroll,
  PageTitle,
} from "common/layouts/WorkspaceLayout";

import ConnectAccount from "./ConnectAccount";
import CreateCampaign from "./CreateCampaign";

export default function InboxEmptyPlaceholder() {
  const { accounts_count: accountsCount } = useSelectedWorkspaceContext();
  const hasAccount = accountsCount > 0;

  return (
    <ContentContainer>
      <ContentHeader>
        <PageTitle />
      </ContentHeader>

      <ContentScroll className="p-4">
        {hasAccount ? <CreateCampaign /> : <ConnectAccount />}
      </ContentScroll>
    </ContentContainer>
  );
}
